export interface ChangeWorkOrderFirewallPriorityDto {
	priority: number;
	workOrderId: number;
}

export class ChangeWorkOrderFirewallPriorityDto implements ChangeWorkOrderFirewallPriorityDto {
	constructor(data?: Partial<ChangeWorkOrderFirewallPriorityDto>) {
		if (data) {
			for (const key of Object.keys(data)) {
				(this as any)[key] = (data as any)[key];
			}
		}
	}
}